import React, { useEffect, useState } from 'react';
import { getAbonnes, getPartenaires } from '../services/api';

const Abonnes: React.FC = () => {
  const [abonnes, setAbonnes] = useState<any[]>([]);
  const [partenaires, setPartenaires] = useState<any[]>([]);
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [filters, setFilters] = useState<any>({});

  useEffect(() => { getPartenaires().then(r => setPartenaires(r.data)); }, []);

  useEffect(() => {
    const params: Record<string, string> = { page: page.toString(), limit: '30' };
    Object.entries(filters).forEach(([k, v]) => { if (v) params[k] = v as string; });
    getAbonnes(params).then(r => {
      setAbonnes(r.data.data);
      setTotal(r.data.total);
      setTotalPages(r.data.totalPages);
    });
  }, [page, filters]);

  return (
    <div>
      <h2 style={{ marginBottom: 20, color: '#333' }}>Abonnes ({total.toLocaleString('fr-FR')})</h2>

      <div className="filters-bar">
        <select value={filters.partenaire_id || ''} onChange={e => { setFilters({ ...filters, partenaire_id: e.target.value }); setPage(1); }}>
          <option value="">Tous les partenaires</option>
          {partenaires.map(p => <option key={p.id} value={p.id}>{p.libelle}</option>)}
        </select>
        <input
          type="text" placeholder="Rechercher un abonne..."
          value={filters.search || ''}
          onChange={e => { setFilters({ ...filters, search: e.target.value }); setPage(1); }}
        />
      </div>

      <div className="data-table-wrapper">
        <table className="data-table">
          <thead>
            <tr>
              <th>Reference</th>
              <th>Prenom Nom</th>
              <th>Partenaire</th>
              <th>Secteur</th>
              <th>Categorie</th>
              <th>Telephone</th>
              <th>Dernier Index</th>
              <th>Reste a payer</th>
              <th>Etat</th>
            </tr>
          </thead>
          <tbody>
            {abonnes.map((a: any) => (
              <tr key={a.id}>
                <td><strong>{a.reference}</strong></td>
                <td>{a.prenomnom || `${a.prenom} ${a.nom}`}</td>
                <td>{a.partenaire}</td>
                <td>{a.secteur}</td>
                <td>{a.categorie}</td>
                <td>{a.telephone}</td>
                <td>{a.lastindex}</td>
                <td style={{ color: a.resteapayer > 0 ? '#c62828' : '#2e7d32', fontWeight: 600 }}>
                  {a.resteapayer?.toLocaleString('fr-FR')} FCFA
                </td>
                <td>
                  <span style={{
                    padding: '3px 10px', borderRadius: 12, fontSize: 12,
                    background: a.etat === 1 ? '#e8f5e9' : '#ffebee',
                    color: a.etat === 1 ? '#2e7d32' : '#c62828'
                  }}>
                    {a.etat === 1 ? 'Actif' : 'Inactif'}
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div className="pagination">
        <button disabled={page <= 1} onClick={() => setPage(page - 1)}>Precedent</button>
        <span style={{ padding: '8px 14px', fontSize: 14 }}>Page {page} / {totalPages}</span>
        <button disabled={page >= totalPages} onClick={() => setPage(page + 1)}>Suivant</button>
      </div>
    </div>
  );
};

export default Abonnes;
